module.exports = __webpack_public_path__ + "img/20200513_152250.0a6e4d0c.jpg";